/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api/lib/types";
import * as Observable from "zen-observable";

export type CreateUserInput = {
  firstname: string;
  lastname: string;
  email: string;
  userCompany?: string | null;
  password: string;
  acl?: string | null;
  group?: string | null;
  role?: string | null;
};

export type UpdateUserInput = {
  username: string;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  userCompany?: string | null;
  acl?: string | null;
  role?: string | null;
  active?: boolean | null;
};

export type DeleteUserInput = {
  username: string;
};

export type CreatePCGInput = {
  id: string;
  label: string;
};

export type UpdatePCGInput = {
  id: string;
  label: string;
};

export type DeletePCGInput = {
  id: string;
};

export type CreateCompanyInput = {
  id: string;
  name: string;
  untilDateExcluded?: string | null;
  lastFileUpload?: string | null;
  lastAccountingFileUploadSuccess?: string | null;
  lastPayrollFileUploadSuccess?: string | null;
  lastBalanceFileUploadSuccess?: string | null;
  lastParametersFileUploadSuccess?: string | null;
  lastAccountingFileUploadSuccessDate?: string | null;
  lastPayrollFileUploadSuccessDate?: string | null;
  accountingAnalysis?: AccountingAnalysisInput | null;
  balanceAnalysis?: BalanceAnalysisInput | null;
  accountingYears?: Array<AccountingYearInput | null> | null;
  template10?: string | null;
  importOptions?: string | null;
  exportOptions?: string | null;
};

export type AccountingAnalysisInput = {
  months?: string | null;
  // map[string]MonthSummary
  debit?: number | null;
  credit?: number | null;
  lines?: number | null;
  isBalanced?: boolean | null;
};

export type BalanceAnalysisInput = {
  missingLabels?: Array<string | null> | null;
  debit?: number | null;
  credit?: number | null;
  lines?: number | null;
  isBalanced?: boolean | null;
};

export type AccountingYearInput = {
  startDate: string;
  endDate?: string | null;
  closedAccounting?: boolean | null;
};

export type UpdateCompanyInput = {
  id: string;
  name?: string | null;
  untilDateExcluded?: string | null;
  lastFileUpload?: string | null;
  lastAccountingFileUploadSuccess?: string | null;
  lastPayrollFileUploadSuccess?: string | null;
  lastBalanceFileUploadSuccess?: string | null;
  lastParametersFileUploadSuccess?: string | null;
  lastAccountingFileUploadSuccessDate?: string | null;
  lastPayrollFileUploadSuccessDate?: string | null;
  accountingAnalysis?: AccountingAnalysisInput | null;
  balanceAnalysis?: BalanceAnalysisInput | null;
  template10?: string | null;
  accountingYears?: Array<AccountingYearInput | null> | null;
  importOptions?: string | null;
  exportOptions?: string | null;
};

export type DeleteCompanyInput = {
  id: string;
};

export type DeleteCompanyDataInput = {
  id: string;
  dataType: string;
};

export type CreateJournalEntryInput = {
  companyId: string;
  key: string;
  name?: string | null;
};

export type UpdateJournalEntryInput = {
  companyId: string;
  key: string;
  name?: string | null;
};

export type DeleteJournalEntryInput = {
  companyId: string;
  key: string;
};

export type CreateAccountingEntryInput = {
  companyId: string;
  key: string;
  entryDate: string;
  journal: string;
  account: string;
  auxiliary?: string | null;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
  lettering?: string | null;
  reference?: string | null;
  document?: string | null;
  accountLabel?: string | null;
  compAuxLib?: string | null;
  journalLib?: string | null;
  dateLet?: string | null;
  pieceDate?: string | null;
  validDate?: string | null;
  montDevise?: number | null;
  iDevise?: string | null;
  row?: number | null;
};

export type UpdateAccountingEntryInput = {
  companyId: string;
  key: string;
  entryDate?: string | null;
  journal?: string | null;
  account?: string | null;
  auxiliary?: string | null;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
  lettering?: string | null;
  reference?: string | null;
  document?: string | null;
  accountLabel?: string | null;
  compAuxLib?: string | null;
  journalLib?: string | null;
  dateLet?: string | null;
  pieceDate?: string | null;
  validDate?: string | null;
  montDevise?: number | null;
  iDevise?: string | null;
  row?: number | null;
};

export type DeleteAccountingEntryInput = {
  companyId: string;
  key: string;
};

export type CreatePayrollEntryInput = {
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month: string;
  name: string;
  raw?: number | null;
  extra?: number | null;
  primes?: number | null;
  others?: number | null;
  plannedRaw?: number | null;
  categoryPro?: string | null;
  isjei?: string | null;
  extracolumn?: string | null;
  row?: number | null;
};

export type UpdatePayrollEntryInput = {
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month?: string | null;
  name: string;
  raw?: number | null;
  extra?: number | null;
  primes?: number | null;
  others?: number | null;
  plannedRaw?: number | null;
  categoryPro?: string | null;
  isjei?: string | null;
  extracolumn?: string | null;
  row?: number | null;
};

export type DeletePayrollEntryInput = {
  companyId: string;
  key: string;
};

export type CreatePayrollExtraEntryInput = {
  companyId: string;
  key?: string | null;
  id?: string | null;
  name: string;
  applicable: boolean;
  combobox: boolean;
  choices?: string | null;
};

export type UpdatePayrollExtraEntryInput = {
  companyId: string;
  key: string;
  name?: string | null;
  applicable?: boolean | null;
  combobox?: boolean | null;
  choices?: string | null;
};

export type CreatePayrollRuleEntryInput = {
  companyId: string;
  key?: string | null;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type UpdatePayrollRuleEntryInput = {
  companyId: string;
  key?: string | null;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type DeletePayrollRuleEntryInput = {
  companyId: string;
  key: string;
};

export type CreateCubeEntryInput = {
  companyId: string;
  key: string;
  entryDate: string;
  journal?: string | null;
  originalJournal: string;
  account: string;
  auxiliary?: string | null;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
  lettering?: string | null;
  row?: number | null;
  accountLabel?: string | null;
  auxiliaryLabel?: string | null;
  timeline?: string | null;
  gen1?: string | null;
  gen2?: string | null;
  gen3?: string | null;
};

export type UpdateCubeEntryInput = {
  companyId: string;
  key: string;
  entryDate?: string | null;
  journal?: string | null;
  originalJournal?: string | null;
  account?: string | null;
  auxiliary?: string | null;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
  lettering?: string | null;
  row?: number | null;
  accountLabel?: string | null;
  auxiliaryLabel?: string | null;
  timeline?: string | null;
  gen1?: string | null;
  gen2?: string | null;
  gen3?: string | null;
};

export type DeleteCubeEntryInput = {
  companyId: string;
  key: string;
};

export type CreateBalanceEntryInput = {
  companyId: string;
  key: string;
  account: string;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
};

export type UpdateBalanceEntryInput = {
  companyId: string;
  key: string;
  account?: string | null;
  entryLabel?: string | null;
  debit?: number | null;
  credit?: number | null;
};

export type DeleteBalanceEntryInput = {
  companyId: string;
  key: string;
};

export type CreateAnalyticsEntryInput = {
  companyId: string;
  axis: string;
  name: string;
  description?: string | null;
  sortOrder?: number | null;
  parentKey?: string | null;
  groups?: Array<string | null> | null;
  paymentPeriod?: string | null;
  isCash?: boolean | null;
  groupType?: string | null;
  color?: string | null;
};

export type UpdateAnalyticsEntryInput = {
  companyId: string;
  key: string;
  name?: string | null;
  description?: string | null;
  sortOrder?: number | null;
  parentKey?: string | null;
  groups?: Array<string | null> | null;
  paymentPeriod?: string | null;
  isCash?: boolean | null;
  groupType?: string | null;
  color?: string | null;
};

export type UpdateAnalyticsEntrySortInput = {
  companyId: string;
  key: string;
  sortOrder: number;
};

export type DeleteAnalyticsEntryInput = {
  companyId: string;
  key: string;
};

export type GroupAnalyticsEntryInput = {
  companyId: string;
  key: string;
  groupKey: string;
};

export type CreateFileUploadEntryInput = {
  companyId: string;
  sourceFilename: string;
  fileType: string;
  startDate?: string | null;
  untilDateExcluded?: string | null;
  closedAccounting?: boolean | null;
};

export type UpdateFileUploadEntryInput = {
  companyId: string;
  key: string;
  s3SignedURL?: string | null;
  sourceFilename?: string | null;
  fileType?: string | null;
  uploadDate?: string | null;
  startDate?: string | null;
  untilDateExcluded?: string | null;
  closedAccounting?: boolean | null;
  accountingSheet?: ImportResultInput | null;
  balanceSheet?: ImportResultInput | null;
  payrollSheet?: ImportResultInput | null;
  payrollExtraSheet?: ImportResultInput | null;
  planSheet?: ImportResultInput | null;
  analyticsSheet?: ImportResultInput | null;
  customerSheet?: ImportResultInput | null;
  providerSheet?: ImportResultInput | null;
  journalSheet?: ImportResultInput | null;
  importResult?: ImportResultInput | null;
};

export type ImportResultInput = {
  status: string;
  rows?: number | null;
  ignoredRows?: number | null;
  message?: string | null;
};

export type DeleteFileUploadEntryInput = {
  companyId: string;
  key: string;
};

export type CreateRuleEntryInput = {
  companyId: string;
  axis: string;
  name: string;
  target: string;
  anaKey?: string | null;
  sortOrder?: number | null;
};

export type UpdateRuleEntryInput = {
  companyId: string;
  key: string;
  name?: string | null;
  target?: string | null;
  anaKey?: string | null;
  sortOrder?: number | null;
};

export type DeleteRuleEntryInput = {
  companyId: string;
  key: string;
};

export type CreatePlanEntryInput = {
  companyId: string;
  account: string;
  anaKey?: string | null;
};

export type UpdatePlanEntryInput = {
  companyId: string;
  account: string;
  anaKey?: string | null;
};

export type DeletePlanEntryInput = {
  companyId: string;
  account: string;
};

export type UserFilterInput = {
  username?: StringFilterInput | null;
  firstname?: StringFilterInput | null;
  lastname?: StringFilterInput | null;
  email?: StringFilterInput | null;
  userCompany?: StringFilterInput | null;
  group?: StringFilterInput | null;
  role?: StringFilterInput | null;
  active?: BooleanFilterInput | null;
};

export type StringFilterInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  exists?: string | null;
  notExists?: string | null;
  beginsWith?: string | null;
  between?: string | null;
};

export type BooleanFilterInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type PCGFilterInput = {
  id?: StringFilterInput | null;
  label?: StringFilterInput | null;
};

export type CompanyFilterInput = {
  name?: StringFilterInput | null;
  untilDateExcluded?: StringFilterInput | null;
  template10?: StringFilterInput | null;
  lastFileUpload?: StringFilterInput | null;
  lastAccountingFileUploadSuccess?: StringFilterInput | null;
  lastPayrollFileUploadSuccess?: StringFilterInput | null;
  lastBalanceFileUploadSuccess?: StringFilterInput | null;
  lastParametersFileUploadSuccess?: StringFilterInput | null;
  lastAccountingFileUploadSuccessDate?: StringFilterInput | null;
  lastPayrollFileUploadSuccessDate?: StringFilterInput | null;
};

export type CreateUserMutation = {
  __typename: "User";
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
};

export type UpdateUserMutation = {
  __typename: "User";
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
};

export type DeleteUserMutation = {
  __typename: "User";
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
};

export type CreatePcgEntryMutation = {
  __typename: "PCGEntry";
  id: string;
  label: string;
};

export type UpdatePcgEntryMutation = {
  __typename: "PCGEntry";
  id: string;
  label: string;
};

export type DeletePcgEntryMutation = {
  __typename: "PCGEntry";
  id: string;
  label: string;
};

export type CreateCompanyMutation = {
  __typename: "Company";
  id: string;
  name: string;
  untilDateExcluded: string | null;
  template10: string | null;
  lastFileUpload: string | null;
  lastAccountingFileUploadSuccess: string | null;
  lastPayrollFileUploadSuccess: string | null;
  lastBalanceFileUploadSuccess: string | null;
  lastParametersFileUploadSuccess: string | null;
  lastAccountingFileUploadSuccessDate: string | null;
  lastPayrollFileUploadSuccessDate: string | null;
  accountingAnalysis: {
    __typename: "AccountingAnalysis";
    months: string | null;
    // map[string]MonthSummary
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  balanceAnalysis: {
    __typename: "BalanceAnalysis";
    missingLabels: Array<string | null> | null;
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  accountingYears: Array<{
    __typename: "AccountingYear";
    startDate: string;
    endDate: string | null;
    closedAccounting: boolean | null;
  } | null> | null;
  importOptions: string | null;
  exportOptions: string | null;
  journal: {
    __typename: "JournalConnection";
    lastEvaluatedKey: string | null;
  } | null;
  accounting: {
    __typename: "AccountingConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payroll: {
    __typename: "PayrollConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollExtra: {
    __typename: "PayrollExtraConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollRule: {
    __typename: "PayrollRuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  balance: {
    __typename: "BalanceConnection";
    lastEvaluatedKey: string | null;
  } | null;
  analytics: {
    __typename: "AnalyticsConnection";
    lastEvaluatedKey: string | null;
  } | null;
  fileUpload: {
    __typename: "FileUploadConnection";
    lastEvaluatedKey: string | null;
  } | null;
  cube: {
    __typename: "CubeConnection";
    lastEvaluatedKey: string | null;
  } | null;
  rule: {
    __typename: "RuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  plan: {
    __typename: "PlanConnection";
    lastEvaluatedKey: string | null;
  } | null;
};

export type UpdateCompanyMutation = {
  __typename: "Company";
  id: string;
  name: string;
  untilDateExcluded: string | null;
  template10: string | null;
  lastFileUpload: string | null;
  lastAccountingFileUploadSuccess: string | null;
  lastPayrollFileUploadSuccess: string | null;
  lastBalanceFileUploadSuccess: string | null;
  lastParametersFileUploadSuccess: string | null;
  lastAccountingFileUploadSuccessDate: string | null;
  lastPayrollFileUploadSuccessDate: string | null;
  accountingAnalysis: {
    __typename: "AccountingAnalysis";
    months: string | null;
    // map[string]MonthSummary
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  balanceAnalysis: {
    __typename: "BalanceAnalysis";
    missingLabels: Array<string | null> | null;
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  accountingYears: Array<{
    __typename: "AccountingYear";
    startDate: string;
    endDate: string | null;
    closedAccounting: boolean | null;
  } | null> | null;
  importOptions: string | null;
  exportOptions: string | null;
  journal: {
    __typename: "JournalConnection";
    lastEvaluatedKey: string | null;
  } | null;
  accounting: {
    __typename: "AccountingConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payroll: {
    __typename: "PayrollConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollExtra: {
    __typename: "PayrollExtraConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollRule: {
    __typename: "PayrollRuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  balance: {
    __typename: "BalanceConnection";
    lastEvaluatedKey: string | null;
  } | null;
  analytics: {
    __typename: "AnalyticsConnection";
    lastEvaluatedKey: string | null;
  } | null;
  fileUpload: {
    __typename: "FileUploadConnection";
    lastEvaluatedKey: string | null;
  } | null;
  cube: {
    __typename: "CubeConnection";
    lastEvaluatedKey: string | null;
  } | null;
  rule: {
    __typename: "RuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  plan: {
    __typename: "PlanConnection";
    lastEvaluatedKey: string | null;
  } | null;
};

export type DeleteCompanyMutation = {
  __typename: "Company";
  id: string;
  name: string;
  untilDateExcluded: string | null;
  template10: string | null;
  lastFileUpload: string | null;
  lastAccountingFileUploadSuccess: string | null;
  lastPayrollFileUploadSuccess: string | null;
  lastBalanceFileUploadSuccess: string | null;
  lastParametersFileUploadSuccess: string | null;
  lastAccountingFileUploadSuccessDate: string | null;
  lastPayrollFileUploadSuccessDate: string | null;
  accountingAnalysis: {
    __typename: "AccountingAnalysis";
    months: string | null;
    // map[string]MonthSummary
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  balanceAnalysis: {
    __typename: "BalanceAnalysis";
    missingLabels: Array<string | null> | null;
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  accountingYears: Array<{
    __typename: "AccountingYear";
    startDate: string;
    endDate: string | null;
    closedAccounting: boolean | null;
  } | null> | null;
  importOptions: string | null;
  exportOptions: string | null;
  journal: {
    __typename: "JournalConnection";
    lastEvaluatedKey: string | null;
  } | null;
  accounting: {
    __typename: "AccountingConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payroll: {
    __typename: "PayrollConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollExtra: {
    __typename: "PayrollExtraConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollRule: {
    __typename: "PayrollRuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  balance: {
    __typename: "BalanceConnection";
    lastEvaluatedKey: string | null;
  } | null;
  analytics: {
    __typename: "AnalyticsConnection";
    lastEvaluatedKey: string | null;
  } | null;
  fileUpload: {
    __typename: "FileUploadConnection";
    lastEvaluatedKey: string | null;
  } | null;
  cube: {
    __typename: "CubeConnection";
    lastEvaluatedKey: string | null;
  } | null;
  rule: {
    __typename: "RuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  plan: {
    __typename: "PlanConnection";
    lastEvaluatedKey: string | null;
  } | null;
};

export type DeleteCompanyDataMutation = {
  __typename: "Company";
  id: string;
  name: string;
  untilDateExcluded: string | null;
  template10: string | null;
  lastFileUpload: string | null;
  lastAccountingFileUploadSuccess: string | null;
  lastPayrollFileUploadSuccess: string | null;
  lastBalanceFileUploadSuccess: string | null;
  lastParametersFileUploadSuccess: string | null;
  lastAccountingFileUploadSuccessDate: string | null;
  lastPayrollFileUploadSuccessDate: string | null;
  accountingAnalysis: {
    __typename: "AccountingAnalysis";
    months: string | null;
    // map[string]MonthSummary
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  balanceAnalysis: {
    __typename: "BalanceAnalysis";
    missingLabels: Array<string | null> | null;
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  accountingYears: Array<{
    __typename: "AccountingYear";
    startDate: string;
    endDate: string | null;
    closedAccounting: boolean | null;
  } | null> | null;
  importOptions: string | null;
  exportOptions: string | null;
  journal: {
    __typename: "JournalConnection";
    lastEvaluatedKey: string | null;
  } | null;
  accounting: {
    __typename: "AccountingConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payroll: {
    __typename: "PayrollConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollExtra: {
    __typename: "PayrollExtraConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollRule: {
    __typename: "PayrollRuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  balance: {
    __typename: "BalanceConnection";
    lastEvaluatedKey: string | null;
  } | null;
  analytics: {
    __typename: "AnalyticsConnection";
    lastEvaluatedKey: string | null;
  } | null;
  fileUpload: {
    __typename: "FileUploadConnection";
    lastEvaluatedKey: string | null;
  } | null;
  cube: {
    __typename: "CubeConnection";
    lastEvaluatedKey: string | null;
  } | null;
  rule: {
    __typename: "RuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  plan: {
    __typename: "PlanConnection";
    lastEvaluatedKey: string | null;
  } | null;
};

export type CreateJournalEntryMutation = {
  __typename: "JournalEntry";
  companyId: string;
  key: string;
  name: string | null;
};

export type UpdateJournalEntryMutation = {
  __typename: "JournalEntry";
  companyId: string;
  key: string;
  name: string | null;
};

export type DeleteJournalEntryMutation = {
  __typename: "JournalEntry";
  companyId: string;
  key: string;
  name: string | null;
};

export type CreateAccountingEntryMutation = {
  __typename: "AccountingEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  reference: string | null;
  document: string | null;
  accountLabel: string | null;
  compAuxLib: string | null;
  journalLib: string | null;
  dateLet: string | null;
  pieceDate: string | null;
  validDate: string | null;
  montDevise: number | null;
  iDevise: string | null;
  row: number | null;
};

export type UpdateAccountingEntryMutation = {
  __typename: "AccountingEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  reference: string | null;
  document: string | null;
  accountLabel: string | null;
  compAuxLib: string | null;
  journalLib: string | null;
  dateLet: string | null;
  pieceDate: string | null;
  validDate: string | null;
  montDevise: number | null;
  iDevise: string | null;
  row: number | null;
};

export type DeleteAccountingEntryMutation = {
  __typename: "AccountingEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  reference: string | null;
  document: string | null;
  accountLabel: string | null;
  compAuxLib: string | null;
  journalLib: string | null;
  dateLet: string | null;
  pieceDate: string | null;
  validDate: string | null;
  montDevise: number | null;
  iDevise: string | null;
  row: number | null;
};

export type CreatePayrollEntryMutation = {
  __typename: "PayrollEntry";
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month: string;
  name: string;
  raw: number | null;
  extra: number | null;
  primes: number | null;
  others: number | null;
  plannedRaw: number | null;
  categoryPro: string | null;
  isjei: string | null;
  extracolumn: string | null;
  row: number | null;
};

export type UpdatePayrollEntryMutation = {
  __typename: "PayrollEntry";
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month: string;
  name: string;
  raw: number | null;
  extra: number | null;
  primes: number | null;
  others: number | null;
  plannedRaw: number | null;
  categoryPro: string | null;
  isjei: string | null;
  extracolumn: string | null;
  row: number | null;
};

export type DeletePayrollEntryMutation = {
  __typename: "PayrollEntry";
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month: string;
  name: string;
  raw: number | null;
  extra: number | null;
  primes: number | null;
  others: number | null;
  plannedRaw: number | null;
  categoryPro: string | null;
  isjei: string | null;
  extracolumn: string | null;
  row: number | null;
};

export type CreatePayrollExtraEntryMutation = {
  __typename: "PayrollExtraEntry";
  companyId: string;
  key: string;
  id: string;
  name: string;
  applicable: boolean;
  combobox: boolean | null;
  choices: string | null;
};

export type UpdatePayrollExtraEntryMutation = {
  __typename: "PayrollExtraEntry";
  companyId: string;
  key: string;
  id: string;
  name: string;
  applicable: boolean;
  combobox: boolean | null;
  choices: string | null;
};

export type CreatePayrollRuleEntryMutation = {
  __typename: "PayrollRuleEntry";
  companyId: string;
  key: string;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type UpdatePayrollRuleEntryMutation = {
  __typename: "PayrollRuleEntry";
  companyId: string;
  key: string;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type DeletePayrollRuleEntryMutation = {
  __typename: "PayrollRuleEntry";
  companyId: string;
  key: string;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type CreateCubeEntryMutation = {
  __typename: "CubeEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string | null;
  originalJournal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  row: number | null;
  accountLabel: string | null;
  auxiliaryLabel: string | null;
  timeline: string | null;
  gen1: string | null;
  gen2: string | null;
  gen3: string | null;
};

export type UpdateCubeEntryMutation = {
  __typename: "CubeEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string | null;
  originalJournal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  row: number | null;
  accountLabel: string | null;
  auxiliaryLabel: string | null;
  timeline: string | null;
  gen1: string | null;
  gen2: string | null;
  gen3: string | null;
};

export type DeleteCubeEntryMutation = {
  __typename: "CubeEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string | null;
  originalJournal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  row: number | null;
  accountLabel: string | null;
  auxiliaryLabel: string | null;
  timeline: string | null;
  gen1: string | null;
  gen2: string | null;
  gen3: string | null;
};

export type CreateBalanceEntryMutation = {
  __typename: "BalanceEntry";
  companyId: string;
  key: string;
  account: string;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
};

export type UpdateBalanceEntryMutation = {
  __typename: "BalanceEntry";
  companyId: string;
  key: string;
  account: string;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
};

export type DeleteBalanceEntryMutation = {
  __typename: "BalanceEntry";
  companyId: string;
  key: string;
  account: string;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
};

export type CreateAnalyticsEntryMutation = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type UpdateAnalyticsEntryMutation = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type DeleteAnalyticsEntryMutation = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type AddGroupAnalyticsEntryMutation = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type RemoveGroupAnalyticsEntryMutation = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type CreateFileUploadEntryMutation = {
  __typename: "FileUploadEntry";
  companyId: string;
  key: string;
  s3SignedURL: string | null;
  sourceFilename: string;
  fileType: string;
  uploadDate: string;
  startDate: string | null;
  untilDateExcluded: string | null;
  closedAccounting: boolean | null;
  accountingSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  balanceSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollExtraSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  planSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  analyticsSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  customerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  providerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  journalSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  importResult: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
};

export type UpdateFileUploadEntryMutation = {
  __typename: "FileUploadEntry";
  companyId: string;
  key: string;
  s3SignedURL: string | null;
  sourceFilename: string;
  fileType: string;
  uploadDate: string;
  startDate: string | null;
  untilDateExcluded: string | null;
  closedAccounting: boolean | null;
  accountingSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  balanceSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollExtraSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  planSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  analyticsSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  customerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  providerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  journalSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  importResult: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
};

export type DeleteFileUploadEntryMutation = {
  __typename: "FileUploadEntry";
  companyId: string;
  key: string;
  s3SignedURL: string | null;
  sourceFilename: string;
  fileType: string;
  uploadDate: string;
  startDate: string | null;
  untilDateExcluded: string | null;
  closedAccounting: boolean | null;
  accountingSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  balanceSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollExtraSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  planSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  analyticsSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  customerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  providerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  journalSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  importResult: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
};

export type CreateRuleEntryMutation = {
  __typename: "RuleEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  target: string;
  anaKey: string | null;
  sortOrder: number | null;
};

export type UpdateRuleEntryMutation = {
  __typename: "RuleEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  target: string;
  anaKey: string | null;
  sortOrder: number | null;
};

export type DeleteRuleEntryMutation = {
  __typename: "RuleEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  target: string;
  anaKey: string | null;
  sortOrder: number | null;
};

export type CreatePlanEntryMutation = {
  __typename: "PlanEntry";
  companyId: string;
  account: string;
  anaKey: string | null;
};

export type UpdatePlanEntryMutation = {
  __typename: "PlanEntry";
  companyId: string;
  account: string;
  anaKey: string | null;
};

export type DeletePlanEntryMutation = {
  __typename: "PlanEntry";
  companyId: string;
  account: string;
  anaKey: string | null;
};

export type MeQuery = {
  __typename: "User";
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
};

export type UserQuery = {
  __typename: "User";
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
};

export type UsersQuery = {
  __typename: "UserConnection";
  items: Array<{
    __typename: "User";
    username: string;
    firstname: string;
    lastname: string;
    email: string;
    userCompany: string | null;
    acl: string | null;
    group: string;
    role: string;
    active: boolean;
  } | null> | null;
  lastEvaluatedKey: string | null;
};

export type PcgEntryQuery = {
  __typename: "PCGEntry";
  id: string;
  label: string;
};

export type PcgQuery = {
  __typename: "PCGConnection";
  items: Array<{
    __typename: "PCGEntry";
    id: string;
    label: string;
  } | null> | null;
  lastEvaluatedKey: string | null;
};

export type CompanyQuery = {
  __typename: "Company";
  id: string;
  name: string;
  untilDateExcluded: string | null;
  template10: string | null;
  lastFileUpload: string | null;
  lastAccountingFileUploadSuccess: string | null;
  lastPayrollFileUploadSuccess: string | null;
  lastBalanceFileUploadSuccess: string | null;
  lastParametersFileUploadSuccess: string | null;
  lastAccountingFileUploadSuccessDate: string | null;
  lastPayrollFileUploadSuccessDate: string | null;
  accountingAnalysis: {
    __typename: "AccountingAnalysis";
    months: string | null;
    // map[string]MonthSummary
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  balanceAnalysis: {
    __typename: "BalanceAnalysis";
    missingLabels: Array<string | null> | null;
    debit: number | null;
    credit: number | null;
    lines: number | null;
    isBalanced: boolean | null;
  } | null;
  accountingYears: Array<{
    __typename: "AccountingYear";
    startDate: string;
    endDate: string | null;
    closedAccounting: boolean | null;
  } | null> | null;
  importOptions: string | null;
  exportOptions: string | null;
  journal: {
    __typename: "JournalConnection";
    lastEvaluatedKey: string | null;
  } | null;
  accounting: {
    __typename: "AccountingConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payroll: {
    __typename: "PayrollConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollExtra: {
    __typename: "PayrollExtraConnection";
    lastEvaluatedKey: string | null;
  } | null;
  payrollRule: {
    __typename: "PayrollRuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  balance: {
    __typename: "BalanceConnection";
    lastEvaluatedKey: string | null;
  } | null;
  analytics: {
    __typename: "AnalyticsConnection";
    lastEvaluatedKey: string | null;
  } | null;
  fileUpload: {
    __typename: "FileUploadConnection";
    lastEvaluatedKey: string | null;
  } | null;
  cube: {
    __typename: "CubeConnection";
    lastEvaluatedKey: string | null;
  } | null;
  rule: {
    __typename: "RuleConnection";
    lastEvaluatedKey: string | null;
  } | null;
  plan: {
    __typename: "PlanConnection";
    lastEvaluatedKey: string | null;
  } | null;
};

export type JournalEntryQuery = {
  __typename: "JournalEntry";
  companyId: string;
  key: string;
  name: string | null;
};

export type AccountingEntryQuery = {
  __typename: "AccountingEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  reference: string | null;
  document: string | null;
  accountLabel: string | null;
  compAuxLib: string | null;
  journalLib: string | null;
  dateLet: string | null;
  pieceDate: string | null;
  validDate: string | null;
  montDevise: number | null;
  iDevise: string | null;
  row: number | null;
};

export type PayrollEntryQuery = {
  __typename: "PayrollEntry";
  companyId: string;
  key: string;
  charges: number;
  matricule: string;
  month: string;
  name: string;
  raw: number | null;
  extra: number | null;
  primes: number | null;
  others: number | null;
  plannedRaw: number | null;
  categoryPro: string | null;
  isjei: string | null;
  extracolumn: string | null;
  row: number | null;
};

export type PayrollExtraEntryQuery = {
  __typename: "PayrollExtraEntry";
  companyId: string;
  key: string;
  id: string;
  name: string;
  applicable: boolean;
  combobox: boolean | null;
  choices: string | null;
};

export type PayrollRuleEntryQuery = {
  __typename: "PayrollRuleEntry";
  companyId: string;
  key: string;
  payrollKey: string;
  payrollExtraKey: string;
  payrollExtraValue: string;
  axis: string;
};

export type CubeEntryQuery = {
  __typename: "CubeEntry";
  companyId: string;
  key: string;
  entryDate: string;
  journal: string | null;
  originalJournal: string;
  account: string;
  auxiliary: string | null;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
  lettering: string | null;
  row: number | null;
  accountLabel: string | null;
  auxiliaryLabel: string | null;
  timeline: string | null;
  gen1: string | null;
  gen2: string | null;
  gen3: string | null;
};

export type BalanceEntryQuery = {
  __typename: "BalanceEntry";
  companyId: string;
  key: string;
  account: string;
  entryLabel: string | null;
  debit: number | null;
  credit: number | null;
};

export type RuleEntryQuery = {
  __typename: "RuleEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  target: string;
  anaKey: string | null;
  sortOrder: number | null;
};

export type PlanEntryQuery = {
  __typename: "PlanEntry";
  companyId: string;
  account: string;
  anaKey: string | null;
};

export type AnalyticsEntryQuery = {
  __typename: "AnalyticsEntry";
  companyId: string;
  key: string;
  axis: string;
  id: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  parentKey: string | null;
  groups: Array<string | null> | null;
  paymentPeriod: string | null;
  isCash: boolean | null;
  groupType: string | null;
  color: string | null;
};

export type InitAnalyticsEntriesQuery = {
  __typename: "AnalyticsConnection";
  items: Array<{
    __typename: "AnalyticsEntry";
    companyId: string;
    key: string;
    axis: string;
    id: string;
    name: string;
    description: string | null;
    sortOrder: number | null;
    parentKey: string | null;
    groups: Array<string | null> | null;
    paymentPeriod: string | null;
    isCash: boolean | null;
    groupType: string | null;
    color: string | null;
  } | null> | null;
  lastEvaluatedKey: string | null;
};

export type FileUploadEntryQuery = {
  __typename: "FileUploadEntry";
  companyId: string;
  key: string;
  s3SignedURL: string | null;
  sourceFilename: string;
  fileType: string;
  uploadDate: string;
  startDate: string | null;
  untilDateExcluded: string | null;
  closedAccounting: boolean | null;
  accountingSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  balanceSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  payrollExtraSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  planSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  analyticsSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  customerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  providerSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  journalSheet: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
  importResult: {
    __typename: "ImportResult";
    status: string;
    rows: number | null;
    ignoredRows: number | null;
    message: string | null;
  } | null;
};

export type CompaniesQuery = {
  __typename: "CompanyConnection";
  items: Array<{
    __typename: "Company";
    id: string;
    name: string;
    untilDateExcluded: string | null;
    template10: string | null;
    lastFileUpload: string | null;
    lastAccountingFileUploadSuccess: string | null;
    lastPayrollFileUploadSuccess: string | null;
    lastBalanceFileUploadSuccess: string | null;
    lastParametersFileUploadSuccess: string | null;
    lastAccountingFileUploadSuccessDate: string | null;
    lastPayrollFileUploadSuccessDate: string | null;
    importOptions: string | null;
    exportOptions: string | null;
  } | null> | null;
  lastEvaluatedKey: string | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreateUser(input: CreateUserInput): Promise<CreateUserMutation> {
    const statement = `mutation CreateUser($input: CreateUserInput!) {
        createUser(input: $input) {
          __typename
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateUserMutation>response.data.createUser;
  }
  async UpdateUser(input: UpdateUserInput): Promise<UpdateUserMutation> {
    const statement = `mutation UpdateUser($input: UpdateUserInput!) {
        updateUser(input: $input) {
          __typename
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateUserMutation>response.data.updateUser;
  }
  async DeleteUser(input: DeleteUserInput): Promise<DeleteUserMutation> {
    const statement = `mutation DeleteUser($input: DeleteUserInput!) {
        deleteUser(input: $input) {
          __typename
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteUserMutation>response.data.deleteUser;
  }
  async CreatePcgEntry(input: CreatePCGInput): Promise<CreatePcgEntryMutation> {
    const statement = `mutation CreatePcgEntry($input: CreatePCGInput!) {
        createPCGEntry(input: $input) {
          __typename
          id
          label
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePcgEntryMutation>response.data.createPCGEntry;
  }
  async UpdatePcgEntry(input: UpdatePCGInput): Promise<UpdatePcgEntryMutation> {
    const statement = `mutation UpdatePcgEntry($input: UpdatePCGInput!) {
        updatePCGEntry(input: $input) {
          __typename
          id
          label
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePcgEntryMutation>response.data.updatePCGEntry;
  }
  async DeletePcgEntry(input: DeletePCGInput): Promise<DeletePcgEntryMutation> {
    const statement = `mutation DeletePcgEntry($input: DeletePCGInput!) {
        deletePCGEntry(input: $input) {
          __typename
          id
          label
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePcgEntryMutation>response.data.deletePCGEntry;
  }
  async CreateCompany(
    input: CreateCompanyInput
  ): Promise<CreateCompanyMutation> {
    const statement = `mutation CreateCompany($input: CreateCompanyInput!) {
        createCompany(input: $input) {
          __typename
          id
          name
          untilDateExcluded
          template10
          lastFileUpload
          lastAccountingFileUploadSuccess
          lastPayrollFileUploadSuccess
          lastBalanceFileUploadSuccess
          lastParametersFileUploadSuccess
          lastAccountingFileUploadSuccessDate
          lastPayrollFileUploadSuccessDate
          accountingAnalysis {
            __typename
            months
            debit
            credit
            lines
            isBalanced
          }
          balanceAnalysis {
            __typename
            missingLabels
            debit
            credit
            lines
            isBalanced
          }
          accountingYears {
            __typename
            startDate
            endDate
            closedAccounting
          }
          importOptions
          exportOptions
          journal {
            __typename
            lastEvaluatedKey
          }
          accounting {
            __typename
            lastEvaluatedKey
          }
          payroll {
            __typename
            lastEvaluatedKey
          }
          payrollExtra {
            __typename
            lastEvaluatedKey
          }
          payrollRule {
            __typename
            lastEvaluatedKey
          }
          balance {
            __typename
            lastEvaluatedKey
          }
          analytics {
            __typename
            lastEvaluatedKey
          }
          fileUpload {
            __typename
            lastEvaluatedKey
          }
          cube {
            __typename
            lastEvaluatedKey
          }
          rule {
            __typename
            lastEvaluatedKey
          }
          plan {
            __typename
            lastEvaluatedKey
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCompanyMutation>response.data.createCompany;
  }
  async UpdateCompany(
    input: UpdateCompanyInput
  ): Promise<UpdateCompanyMutation> {
    const statement = `mutation UpdateCompany($input: UpdateCompanyInput!) {
        updateCompany(input: $input) {
          __typename
          id
          name
          untilDateExcluded
          template10
          lastFileUpload
          lastAccountingFileUploadSuccess
          lastPayrollFileUploadSuccess
          lastBalanceFileUploadSuccess
          lastParametersFileUploadSuccess
          lastAccountingFileUploadSuccessDate
          lastPayrollFileUploadSuccessDate
          accountingAnalysis {
            __typename
            months
            debit
            credit
            lines
            isBalanced
          }
          balanceAnalysis {
            __typename
            missingLabels
            debit
            credit
            lines
            isBalanced
          }
          accountingYears {
            __typename
            startDate
            endDate
            closedAccounting
          }
          importOptions
          exportOptions
          journal {
            __typename
            lastEvaluatedKey
          }
          accounting {
            __typename
            lastEvaluatedKey
          }
          payroll {
            __typename
            lastEvaluatedKey
          }
          payrollExtra {
            __typename
            lastEvaluatedKey
          }
          payrollRule {
            __typename
            lastEvaluatedKey
          }
          balance {
            __typename
            lastEvaluatedKey
          }
          analytics {
            __typename
            lastEvaluatedKey
          }
          fileUpload {
            __typename
            lastEvaluatedKey
          }
          cube {
            __typename
            lastEvaluatedKey
          }
          rule {
            __typename
            lastEvaluatedKey
          }
          plan {
            __typename
            lastEvaluatedKey
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCompanyMutation>response.data.updateCompany;
  }
  async DeleteCompany(
    input: DeleteCompanyInput
  ): Promise<DeleteCompanyMutation> {
    const statement = `mutation DeleteCompany($input: DeleteCompanyInput!) {
        deleteCompany(input: $input) {
          __typename
          id
          name
          untilDateExcluded
          template10
          lastFileUpload
          lastAccountingFileUploadSuccess
          lastPayrollFileUploadSuccess
          lastBalanceFileUploadSuccess
          lastParametersFileUploadSuccess
          lastAccountingFileUploadSuccessDate
          lastPayrollFileUploadSuccessDate
          accountingAnalysis {
            __typename
            months
            debit
            credit
            lines
            isBalanced
          }
          balanceAnalysis {
            __typename
            missingLabels
            debit
            credit
            lines
            isBalanced
          }
          accountingYears {
            __typename
            startDate
            endDate
            closedAccounting
          }
          importOptions
          exportOptions
          journal {
            __typename
            lastEvaluatedKey
          }
          accounting {
            __typename
            lastEvaluatedKey
          }
          payroll {
            __typename
            lastEvaluatedKey
          }
          payrollExtra {
            __typename
            lastEvaluatedKey
          }
          payrollRule {
            __typename
            lastEvaluatedKey
          }
          balance {
            __typename
            lastEvaluatedKey
          }
          analytics {
            __typename
            lastEvaluatedKey
          }
          fileUpload {
            __typename
            lastEvaluatedKey
          }
          cube {
            __typename
            lastEvaluatedKey
          }
          rule {
            __typename
            lastEvaluatedKey
          }
          plan {
            __typename
            lastEvaluatedKey
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCompanyMutation>response.data.deleteCompany;
  }
  async DeleteCompanyData(
    input: DeleteCompanyDataInput
  ): Promise<DeleteCompanyDataMutation> {
    const statement = `mutation DeleteCompanyData($input: DeleteCompanyDataInput!) {
        deleteCompanyData(input: $input) {
          __typename
          id
          name
          untilDateExcluded
          template10
          lastFileUpload
          lastAccountingFileUploadSuccess
          lastPayrollFileUploadSuccess
          lastBalanceFileUploadSuccess
          lastParametersFileUploadSuccess
          lastAccountingFileUploadSuccessDate
          lastPayrollFileUploadSuccessDate
          accountingAnalysis {
            __typename
            months
            debit
            credit
            lines
            isBalanced
          }
          balanceAnalysis {
            __typename
            missingLabels
            debit
            credit
            lines
            isBalanced
          }
          accountingYears {
            __typename
            startDate
            endDate
            closedAccounting
          }
          importOptions
          exportOptions
          journal {
            __typename
            lastEvaluatedKey
          }
          accounting {
            __typename
            lastEvaluatedKey
          }
          payroll {
            __typename
            lastEvaluatedKey
          }
          payrollExtra {
            __typename
            lastEvaluatedKey
          }
          payrollRule {
            __typename
            lastEvaluatedKey
          }
          balance {
            __typename
            lastEvaluatedKey
          }
          analytics {
            __typename
            lastEvaluatedKey
          }
          fileUpload {
            __typename
            lastEvaluatedKey
          }
          cube {
            __typename
            lastEvaluatedKey
          }
          rule {
            __typename
            lastEvaluatedKey
          }
          plan {
            __typename
            lastEvaluatedKey
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCompanyDataMutation>response.data.deleteCompanyData;
  }
  async CreateJournalEntry(
    input: CreateJournalEntryInput
  ): Promise<CreateJournalEntryMutation> {
    const statement = `mutation CreateJournalEntry($input: CreateJournalEntryInput!) {
        createJournalEntry(input: $input) {
          __typename
          companyId
          key
          name
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateJournalEntryMutation>response.data.createJournalEntry;
  }
  async UpdateJournalEntry(
    input: UpdateJournalEntryInput
  ): Promise<UpdateJournalEntryMutation> {
    const statement = `mutation UpdateJournalEntry($input: UpdateJournalEntryInput!) {
        updateJournalEntry(input: $input) {
          __typename
          companyId
          key
          name
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateJournalEntryMutation>response.data.updateJournalEntry;
  }
  async DeleteJournalEntry(
    input: DeleteJournalEntryInput
  ): Promise<DeleteJournalEntryMutation> {
    const statement = `mutation DeleteJournalEntry($input: DeleteJournalEntryInput!) {
        deleteJournalEntry(input: $input) {
          __typename
          companyId
          key
          name
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteJournalEntryMutation>response.data.deleteJournalEntry;
  }
  async CreateAccountingEntry(
    input: CreateAccountingEntryInput
  ): Promise<CreateAccountingEntryMutation> {
    const statement = `mutation CreateAccountingEntry($input: CreateAccountingEntryInput!) {
        createAccountingEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          reference
          document
          accountLabel
          compAuxLib
          journalLib
          dateLet
          pieceDate
          validDate
          montDevise
          iDevise
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateAccountingEntryMutation>response.data.createAccountingEntry;
  }
  async UpdateAccountingEntry(
    input: UpdateAccountingEntryInput
  ): Promise<UpdateAccountingEntryMutation> {
    const statement = `mutation UpdateAccountingEntry($input: UpdateAccountingEntryInput!) {
        updateAccountingEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          reference
          document
          accountLabel
          compAuxLib
          journalLib
          dateLet
          pieceDate
          validDate
          montDevise
          iDevise
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateAccountingEntryMutation>response.data.updateAccountingEntry;
  }
  async DeleteAccountingEntry(
    input: DeleteAccountingEntryInput
  ): Promise<DeleteAccountingEntryMutation> {
    const statement = `mutation DeleteAccountingEntry($input: DeleteAccountingEntryInput!) {
        deleteAccountingEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          reference
          document
          accountLabel
          compAuxLib
          journalLib
          dateLet
          pieceDate
          validDate
          montDevise
          iDevise
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteAccountingEntryMutation>response.data.deleteAccountingEntry;
  }
  async CreatePayrollEntry(
    input: CreatePayrollEntryInput
  ): Promise<CreatePayrollEntryMutation> {
    const statement = `mutation CreatePayrollEntry($input: CreatePayrollEntryInput!) {
        createPayrollEntry(input: $input) {
          __typename
          companyId
          key
          charges
          matricule
          month
          name
          raw
          extra
          primes
          others
          plannedRaw
          categoryPro
          isjei
          extracolumn
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePayrollEntryMutation>response.data.createPayrollEntry;
  }
  async UpdatePayrollEntry(
    input: UpdatePayrollEntryInput
  ): Promise<UpdatePayrollEntryMutation> {
    const statement = `mutation UpdatePayrollEntry($input: UpdatePayrollEntryInput!) {
        updatePayrollEntry(input: $input) {
          __typename
          companyId
          key
          charges
          matricule
          month
          name
          raw
          extra
          primes
          others
          plannedRaw
          categoryPro
          isjei
          extracolumn
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePayrollEntryMutation>response.data.updatePayrollEntry;
  }
  async DeletePayrollEntry(
    input: DeletePayrollEntryInput
  ): Promise<DeletePayrollEntryMutation> {
    const statement = `mutation DeletePayrollEntry($input: DeletePayrollEntryInput!) {
        deletePayrollEntry(input: $input) {
          __typename
          companyId
          key
          charges
          matricule
          month
          name
          raw
          extra
          primes
          others
          plannedRaw
          categoryPro
          isjei
          extracolumn
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePayrollEntryMutation>response.data.deletePayrollEntry;
  }
  async CreatePayrollExtraEntry(
    input: CreatePayrollExtraEntryInput
  ): Promise<CreatePayrollExtraEntryMutation> {
    const statement = `mutation CreatePayrollExtraEntry($input: CreatePayrollExtraEntryInput!) {
        createPayrollExtraEntry(input: $input) {
          __typename
          companyId
          key
          id
          name
          applicable
          combobox
          choices
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePayrollExtraEntryMutation>(
      response.data.createPayrollExtraEntry
    );
  }
  async UpdatePayrollExtraEntry(
    input: UpdatePayrollExtraEntryInput
  ): Promise<UpdatePayrollExtraEntryMutation> {
    const statement = `mutation UpdatePayrollExtraEntry($input: UpdatePayrollExtraEntryInput!) {
        updatePayrollExtraEntry(input: $input) {
          __typename
          companyId
          key
          id
          name
          applicable
          combobox
          choices
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePayrollExtraEntryMutation>(
      response.data.updatePayrollExtraEntry
    );
  }
  async CreatePayrollRuleEntry(
    input: CreatePayrollRuleEntryInput
  ): Promise<CreatePayrollRuleEntryMutation> {
    const statement = `mutation CreatePayrollRuleEntry($input: CreatePayrollRuleEntryInput!) {
        createPayrollRuleEntry(input: $input) {
          __typename
          companyId
          key
          payrollKey
          payrollExtraKey
          payrollExtraValue
          axis
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePayrollRuleEntryMutation>response.data.createPayrollRuleEntry;
  }
  async UpdatePayrollRuleEntry(
    input: UpdatePayrollRuleEntryInput
  ): Promise<UpdatePayrollRuleEntryMutation> {
    const statement = `mutation UpdatePayrollRuleEntry($input: UpdatePayrollRuleEntryInput!) {
        updatePayrollRuleEntry(input: $input) {
          __typename
          companyId
          key
          payrollKey
          payrollExtraKey
          payrollExtraValue
          axis
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePayrollRuleEntryMutation>response.data.updatePayrollRuleEntry;
  }
  async DeletePayrollRuleEntry(
    input: DeletePayrollRuleEntryInput
  ): Promise<DeletePayrollRuleEntryMutation> {
    const statement = `mutation DeletePayrollRuleEntry($input: DeletePayrollRuleEntryInput!) {
        deletePayrollRuleEntry(input: $input) {
          __typename
          companyId
          key
          payrollKey
          payrollExtraKey
          payrollExtraValue
          axis
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePayrollRuleEntryMutation>response.data.deletePayrollRuleEntry;
  }
  async CreateCubeEntry(
    input: CreateCubeEntryInput
  ): Promise<CreateCubeEntryMutation> {
    const statement = `mutation CreateCubeEntry($input: CreateCubeEntryInput!) {
        createCubeEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          originalJournal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          row
          accountLabel
          auxiliaryLabel
          timeline
          gen1
          gen2
          gen3
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCubeEntryMutation>response.data.createCubeEntry;
  }
  async UpdateCubeEntry(
    input: UpdateCubeEntryInput
  ): Promise<UpdateCubeEntryMutation> {
    const statement = `mutation UpdateCubeEntry($input: UpdateCubeEntryInput!) {
        updateCubeEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          originalJournal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          row
          accountLabel
          auxiliaryLabel
          timeline
          gen1
          gen2
          gen3
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCubeEntryMutation>response.data.updateCubeEntry;
  }
  async DeleteCubeEntry(
    input: DeleteCubeEntryInput
  ): Promise<DeleteCubeEntryMutation> {
    const statement = `mutation DeleteCubeEntry($input: DeleteCubeEntryInput!) {
        deleteCubeEntry(input: $input) {
          __typename
          companyId
          key
          entryDate
          journal
          originalJournal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          row
          accountLabel
          auxiliaryLabel
          timeline
          gen1
          gen2
          gen3
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCubeEntryMutation>response.data.deleteCubeEntry;
  }
  async CreateBalanceEntry(
    input: CreateBalanceEntryInput
  ): Promise<CreateBalanceEntryMutation> {
    const statement = `mutation CreateBalanceEntry($input: CreateBalanceEntryInput!) {
        createBalanceEntry(input: $input) {
          __typename
          companyId
          key
          account
          entryLabel
          debit
          credit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateBalanceEntryMutation>response.data.createBalanceEntry;
  }
  async UpdateBalanceEntry(
    input: UpdateBalanceEntryInput
  ): Promise<UpdateBalanceEntryMutation> {
    const statement = `mutation UpdateBalanceEntry($input: UpdateBalanceEntryInput!) {
        updateBalanceEntry(input: $input) {
          __typename
          companyId
          key
          account
          entryLabel
          debit
          credit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateBalanceEntryMutation>response.data.updateBalanceEntry;
  }
  async DeleteBalanceEntry(
    input: DeleteBalanceEntryInput
  ): Promise<DeleteBalanceEntryMutation> {
    const statement = `mutation DeleteBalanceEntry($input: DeleteBalanceEntryInput!) {
        deleteBalanceEntry(input: $input) {
          __typename
          companyId
          key
          account
          entryLabel
          debit
          credit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteBalanceEntryMutation>response.data.deleteBalanceEntry;
  }
  async CreateAnalyticsEntry(
    input: CreateAnalyticsEntryInput
  ): Promise<CreateAnalyticsEntryMutation> {
    const statement = `mutation CreateAnalyticsEntry($input: CreateAnalyticsEntryInput!) {
        createAnalyticsEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateAnalyticsEntryMutation>response.data.createAnalyticsEntry;
  }
  async UpdateAnalyticsEntry(
    input: UpdateAnalyticsEntryInput
  ): Promise<UpdateAnalyticsEntryMutation> {
    const statement = `mutation UpdateAnalyticsEntry($input: UpdateAnalyticsEntryInput!) {
        updateAnalyticsEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateAnalyticsEntryMutation>response.data.updateAnalyticsEntry;
  }
  async UpdateAnalyticsEntrySort(
    input: Array<UpdateAnalyticsEntrySortInput>
  ): Promise<boolean | null> {
    const statement = `mutation UpdateAnalyticsEntrySort($input: [UpdateAnalyticsEntrySortInput!]!) {
        updateAnalyticsEntrySort(input: $input)
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <boolean | null>response.data;
  }
  async DeleteAnalyticsEntry(
    input: DeleteAnalyticsEntryInput
  ): Promise<DeleteAnalyticsEntryMutation> {
    const statement = `mutation DeleteAnalyticsEntry($input: DeleteAnalyticsEntryInput!) {
        deleteAnalyticsEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteAnalyticsEntryMutation>response.data.deleteAnalyticsEntry;
  }
  async AddGroupAnalyticsEntry(
    input: GroupAnalyticsEntryInput
  ): Promise<AddGroupAnalyticsEntryMutation> {
    const statement = `mutation AddGroupAnalyticsEntry($input: GroupAnalyticsEntryInput!) {
        addGroupAnalyticsEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AddGroupAnalyticsEntryMutation>response.data.addGroupAnalyticsEntry;
  }
  async RemoveGroupAnalyticsEntry(
    input: GroupAnalyticsEntryInput
  ): Promise<RemoveGroupAnalyticsEntryMutation> {
    const statement = `mutation RemoveGroupAnalyticsEntry($input: GroupAnalyticsEntryInput!) {
        removeGroupAnalyticsEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RemoveGroupAnalyticsEntryMutation>(
      response.data.removeGroupAnalyticsEntry
    );
  }
  async CreateFileUploadEntry(
    input: CreateFileUploadEntryInput
  ): Promise<CreateFileUploadEntryMutation> {
    const statement = `mutation CreateFileUploadEntry($input: CreateFileUploadEntryInput!) {
        createFileUploadEntry(input: $input) {
          __typename
          companyId
          key
          s3SignedURL
          sourceFilename
          fileType
          uploadDate
          startDate
          untilDateExcluded
          closedAccounting
          accountingSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          balanceSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollExtraSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          planSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          analyticsSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          customerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          providerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          journalSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          importResult {
            __typename
            status
            rows
            ignoredRows
            message
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateFileUploadEntryMutation>response.data.createFileUploadEntry;
  }
  async UpdateFileUploadEntry(
    input: UpdateFileUploadEntryInput
  ): Promise<UpdateFileUploadEntryMutation> {
    const statement = `mutation UpdateFileUploadEntry($input: UpdateFileUploadEntryInput!) {
        updateFileUploadEntry(input: $input) {
          __typename
          companyId
          key
          s3SignedURL
          sourceFilename
          fileType
          uploadDate
          startDate
          untilDateExcluded
          closedAccounting
          accountingSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          balanceSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollExtraSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          planSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          analyticsSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          customerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          providerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          journalSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          importResult {
            __typename
            status
            rows
            ignoredRows
            message
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateFileUploadEntryMutation>response.data.updateFileUploadEntry;
  }
  async DeleteFileUploadEntry(
    input: DeleteFileUploadEntryInput
  ): Promise<DeleteFileUploadEntryMutation> {
    const statement = `mutation DeleteFileUploadEntry($input: DeleteFileUploadEntryInput!) {
        deleteFileUploadEntry(input: $input) {
          __typename
          companyId
          key
          s3SignedURL
          sourceFilename
          fileType
          uploadDate
          startDate
          untilDateExcluded
          closedAccounting
          accountingSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          balanceSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollExtraSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          planSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          analyticsSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          customerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          providerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          journalSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          importResult {
            __typename
            status
            rows
            ignoredRows
            message
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteFileUploadEntryMutation>response.data.deleteFileUploadEntry;
  }
  async CreateRuleEntry(
    input: CreateRuleEntryInput
  ): Promise<CreateRuleEntryMutation> {
    const statement = `mutation CreateRuleEntry($input: CreateRuleEntryInput!) {
        createRuleEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          target
          anaKey
          sortOrder
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateRuleEntryMutation>response.data.createRuleEntry;
  }
  async UpdateRuleEntry(
    input: UpdateRuleEntryInput
  ): Promise<UpdateRuleEntryMutation> {
    const statement = `mutation UpdateRuleEntry($input: UpdateRuleEntryInput!) {
        updateRuleEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          target
          anaKey
          sortOrder
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateRuleEntryMutation>response.data.updateRuleEntry;
  }
  async DeleteRuleEntry(
    input: DeleteRuleEntryInput
  ): Promise<DeleteRuleEntryMutation> {
    const statement = `mutation DeleteRuleEntry($input: DeleteRuleEntryInput!) {
        deleteRuleEntry(input: $input) {
          __typename
          companyId
          key
          axis
          id
          name
          target
          anaKey
          sortOrder
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteRuleEntryMutation>response.data.deleteRuleEntry;
  }
  async CreatePlanEntry(
    input: CreatePlanEntryInput
  ): Promise<CreatePlanEntryMutation> {
    const statement = `mutation CreatePlanEntry($input: CreatePlanEntryInput!) {
        createPlanEntry(input: $input) {
          __typename
          companyId
          account
          anaKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePlanEntryMutation>response.data.createPlanEntry;
  }
  async UpdatePlanEntry(
    input: UpdatePlanEntryInput
  ): Promise<UpdatePlanEntryMutation> {
    const statement = `mutation UpdatePlanEntry($input: UpdatePlanEntryInput!) {
        updatePlanEntry(input: $input) {
          __typename
          companyId
          account
          anaKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePlanEntryMutation>response.data.updatePlanEntry;
  }
  async DeletePlanEntry(
    input: DeletePlanEntryInput
  ): Promise<DeletePlanEntryMutation> {
    const statement = `mutation DeletePlanEntry($input: DeletePlanEntryInput!) {
        deletePlanEntry(input: $input) {
          __typename
          companyId
          account
          anaKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePlanEntryMutation>response.data.deletePlanEntry;
  }
  async Me(): Promise<MeQuery> {
    const statement = `query Me {
        me {
          __typename
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const response = (await API.graphql(graphqlOperation(statement))) as any;
    return <MeQuery>response.data.me;
  }
  async User(username: string): Promise<UserQuery> {
    const statement = `query User($username: String!) {
        user(username: $username) {
          __typename
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const gqlAPIServiceArguments: any = {
      username
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UserQuery>response.data.user;
  }
  async Users(
    filter?: UserFilterInput,
    limit?: number,
    exclusiveStartKey?: string
  ): Promise<UsersQuery> {
    const statement = `query Users($filter: UserFilterInput, $limit: Int, $exclusiveStartKey: AWSJSON) {
        users(filter: $filter, limit: $limit, exclusiveStartKey: $exclusiveStartKey) {
          __typename
          items {
            __typename
            username
            firstname
            lastname
            email
            userCompany
            acl
            group
            role
            active
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (exclusiveStartKey) {
      gqlAPIServiceArguments.exclusiveStartKey = exclusiveStartKey;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UsersQuery>response.data.users;
  }
  async PcgEntry(id: string): Promise<PcgEntryQuery> {
    const statement = `query PcgEntry($id: String!) {
        pcgEntry(id: $id) {
          __typename
          id
          label
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PcgEntryQuery>response.data.pcgEntry;
  }
  async Pcg(
    account?: string,
    filter?: PCGFilterInput,
    limit?: number,
    exclusiveStartKey?: string
  ): Promise<PcgQuery> {
    const statement = `query Pcg($account: String, $filter: PCGFilterInput, $limit: Int, $exclusiveStartKey: AWSJSON) {
        pcg(account: $account, filter: $filter, limit: $limit, exclusiveStartKey: $exclusiveStartKey) {
          __typename
          items {
            __typename
            id
            label
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (account) {
      gqlAPIServiceArguments.account = account;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (exclusiveStartKey) {
      gqlAPIServiceArguments.exclusiveStartKey = exclusiveStartKey;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PcgQuery>response.data.pcg;
  }
  async Company(id: string): Promise<CompanyQuery> {
    const statement = `query Company($id: String!) {
        company(id: $id) {
          __typename
          id
          name
          untilDateExcluded
          template10
          lastFileUpload
          lastAccountingFileUploadSuccess
          lastPayrollFileUploadSuccess
          lastBalanceFileUploadSuccess
          lastParametersFileUploadSuccess
          lastAccountingFileUploadSuccessDate
          lastPayrollFileUploadSuccessDate
          accountingAnalysis {
            __typename
            months
            debit
            credit
            lines
            isBalanced
          }
          balanceAnalysis {
            __typename
            missingLabels
            debit
            credit
            lines
            isBalanced
          }
          accountingYears {
            __typename
            startDate
            endDate
            closedAccounting
          }
          importOptions
          exportOptions
          journal {
            __typename
            lastEvaluatedKey
          }
          accounting {
            __typename
            lastEvaluatedKey
          }
          payroll {
            __typename
            lastEvaluatedKey
          }
          payrollExtra {
            __typename
            lastEvaluatedKey
          }
          payrollRule {
            __typename
            lastEvaluatedKey
          }
          balance {
            __typename
            lastEvaluatedKey
          }
          analytics {
            __typename
            lastEvaluatedKey
          }
          fileUpload {
            __typename
            lastEvaluatedKey
          }
          cube {
            __typename
            lastEvaluatedKey
          }
          rule {
            __typename
            lastEvaluatedKey
          }
          plan {
            __typename
            lastEvaluatedKey
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CompanyQuery>response.data.company;
  }
  async JournalEntry(
    companyId: string,
    key: string
  ): Promise<JournalEntryQuery> {
    const statement = `query JournalEntry($companyId: String!, $key: String!) {
        journalEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          name
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <JournalEntryQuery>response.data.journalEntry;
  }
  async AccountingEntry(
    companyId: string,
    key: string
  ): Promise<AccountingEntryQuery> {
    const statement = `query AccountingEntry($companyId: String!, $key: String!) {
        accountingEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          entryDate
          journal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          reference
          document
          accountLabel
          compAuxLib
          journalLib
          dateLet
          pieceDate
          validDate
          montDevise
          iDevise
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AccountingEntryQuery>response.data.accountingEntry;
  }
  async PayrollEntry(
    companyId: string,
    key: string
  ): Promise<PayrollEntryQuery> {
    const statement = `query PayrollEntry($companyId: String!, $key: String!) {
        payrollEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          charges
          matricule
          month
          name
          raw
          extra
          primes
          others
          plannedRaw
          categoryPro
          isjei
          extracolumn
          row
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PayrollEntryQuery>response.data.payrollEntry;
  }
  async PayrollExtraEntry(
    companyId: string,
    key: string
  ): Promise<PayrollExtraEntryQuery> {
    const statement = `query PayrollExtraEntry($companyId: String!, $key: String!) {
        payrollExtraEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          id
          name
          applicable
          combobox
          choices
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PayrollExtraEntryQuery>response.data.payrollExtraEntry;
  }
  async PayrollRuleEntry(
    companyId: string,
    key: string
  ): Promise<PayrollRuleEntryQuery> {
    const statement = `query PayrollRuleEntry($companyId: String!, $key: String!) {
        payrollRuleEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          payrollKey
          payrollExtraKey
          payrollExtraValue
          axis
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PayrollRuleEntryQuery>response.data.payrollRuleEntry;
  }
  async CubeEntry(companyId: string, key: string): Promise<CubeEntryQuery> {
    const statement = `query CubeEntry($companyId: String!, $key: String!) {
        cubeEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          entryDate
          journal
          originalJournal
          account
          auxiliary
          entryLabel
          debit
          credit
          lettering
          row
          accountLabel
          auxiliaryLabel
          timeline
          gen1
          gen2
          gen3
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CubeEntryQuery>response.data.cubeEntry;
  }
  async BalanceEntry(
    companyId: string,
    key: string
  ): Promise<BalanceEntryQuery> {
    const statement = `query BalanceEntry($companyId: String!, $key: String!) {
        balanceEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          account
          entryLabel
          debit
          credit
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BalanceEntryQuery>response.data.balanceEntry;
  }
  async RuleEntry(companyId: string, key: string): Promise<RuleEntryQuery> {
    const statement = `query RuleEntry($companyId: String!, $key: String!) {
        ruleEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          axis
          id
          name
          target
          anaKey
          sortOrder
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RuleEntryQuery>response.data.ruleEntry;
  }
  async PlanEntry(companyId: string, account: string): Promise<PlanEntryQuery> {
    const statement = `query PlanEntry($companyId: String!, $account: String!) {
        planEntry(companyId: $companyId, account: $account) {
          __typename
          companyId
          account
          anaKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      account
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PlanEntryQuery>response.data.planEntry;
  }
  async AnalyticsEntry(
    companyId: string,
    key: string
  ): Promise<AnalyticsEntryQuery> {
    const statement = `query AnalyticsEntry($companyId: String!, $key: String!) {
        analyticsEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          axis
          id
          name
          description
          sortOrder
          parentKey
          groups
          paymentPeriod
          isCash
          groupType
          color
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <AnalyticsEntryQuery>response.data.analyticsEntry;
  }
  async InitAnalyticsEntries(
    companyId: string
  ): Promise<InitAnalyticsEntriesQuery> {
    const statement = `query InitAnalyticsEntries($companyId: String!) {
        initAnalyticsEntries(companyId: $companyId) {
          __typename
          items {
            __typename
            companyId
            key
            axis
            id
            name
            description
            sortOrder
            parentKey
            groups
            paymentPeriod
            isCash
            groupType
            color
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <InitAnalyticsEntriesQuery>response.data.initAnalyticsEntries;
  }
  async FileUploadEntry(
    companyId: string,
    key: string
  ): Promise<FileUploadEntryQuery> {
    const statement = `query FileUploadEntry($companyId: String!, $key: String!) {
        fileUploadEntry(companyId: $companyId, key: $key) {
          __typename
          companyId
          key
          s3SignedURL
          sourceFilename
          fileType
          uploadDate
          startDate
          untilDateExcluded
          closedAccounting
          accountingSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          balanceSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          payrollExtraSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          planSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          analyticsSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          customerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          providerSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          journalSheet {
            __typename
            status
            rows
            ignoredRows
            message
          }
          importResult {
            __typename
            status
            rows
            ignoredRows
            message
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
      key
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <FileUploadEntryQuery>response.data.fileUploadEntry;
  }
  async Companies(
    filter?: CompanyFilterInput,
    limit?: number,
    exclusiveStartKey?: string
  ): Promise<CompaniesQuery> {
    const statement = `query Companies($filter: CompanyFilterInput, $limit: Int, $exclusiveStartKey: AWSJSON) {
        companies(filter: $filter, limit: $limit, exclusiveStartKey: $exclusiveStartKey) {
          __typename
          items {
            __typename
            id
            name
            untilDateExcluded
            template10
            lastFileUpload
            lastAccountingFileUploadSuccess
            lastPayrollFileUploadSuccess
            lastBalanceFileUploadSuccess
            lastParametersFileUploadSuccess
            lastAccountingFileUploadSuccessDate
            lastPayrollFileUploadSuccessDate
            importOptions
            exportOptions
          }
          lastEvaluatedKey
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (exclusiveStartKey) {
      gqlAPIServiceArguments.exclusiveStartKey = exclusiveStartKey;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CompaniesQuery>response.data.companies;
  }
}
